module.exports = __webpack_public_path__ + "assets/img/1-4-bar-tube.c8ef3bb3.png";